<!-- Begin Page Content -->
<div class="container-fluid">
  <!-- Page Heading -->

  <!-- DataTales Example -->
  <div class="card bg-white shadow mb-4">
    <!-- <div class="card-header bg-white py-3">
      <h1 class="text-gray-800" style="display: inline-block">Element Models</h1>
      <button type="button" class="btn" style="float: right"
        [routerLink]="['/component','models','model-add']">
        Add Models
      </button>
    </div> -->
    <div class="card-body">
      <div class="table-responsive">
        <table datatable [dtOptions]="dtoptions" class="table table-bordered" width="100%"
          *ngIf="models && models.length > 0">
         
          <thead>
            <tr>
              <th>Manufacturer</th>
              <th>Name</th>
             
            </tr>
          </thead>
         
          <tbody>
            <tr *ngFor="let model of models">
              <td>
                <a style="color: black" (click)="navigate(model.Id)">{{ 
                  model.ManufacturerName 
                  }}</a>
            </td>
              <td>
                <a style="color: black" (click)="navigate(model.Id)">{{
                  model.Name
                  }}</a>
              </td>
              
            </tr>
          </tbody>
        </table>
        <p *ngIf="!models || models.length <= 0">No Models Found !</p>
      </div>
    </div>
  </div>
</div>
<!-- /.container-fluid -->